import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { foundationAPI } from '../services/api';

// Reminds someone to acknowledge the team rules in force. Never blocks work (Foundation Q10).
const RulesBanner = () => {
  const [state, setState] = useState(null);
  const [parts, setParts] = useState([]);
  const load = useCallback(() => {
    foundationAPI.myRules().then((r) => setState(r.data)).catch(() => setState(null));
    // Parts 2-8 of the Foundation in force that I have not signed yet (Q14).
    foundationAPI.myParts().then((r) => setParts(r.data.outstanding || [])).catch(() => setParts([]));
  }, []);
  useEffect(() => {
    load();
    window.addEventListener('vec-rules-changed', load);
    return () => window.removeEventListener('vec-rules-changed', load);
  }, [load]);
  const rulesDue = state && state.required && !state.acknowledgement && state.rules;
  if (!rulesDue) {
    if (!parts.length) return null;
    const late = parts.some((p) => p.overdue);
    return (
      <div style={{
        background: late ? '#fef2f2' : '#fff7ed', border: `1px solid ${late ? '#fecaca' : '#fed7aa'}`,
        color: late ? '#991b1b' : '#9a3412', borderRadius: 10, padding: '10px 14px', margin: '0 0 14px', fontSize: 14,
      }}>
        Foundation {parts.map((p) => `Part ${p.part} v${p.version}`).join(', ')} {parts.length === 1 ? 'is' : 'are'} in force. Please read and acknowledge.{' '}
        <Link to="/team-rules?tab=foundation" style={{ fontWeight: 600 }}>Open the Foundation</Link>
      </div>
    );
  }
  const due = state.rules.ack_due ? new Date(state.rules.ack_due).toLocaleDateString(undefined, { day: 'numeric', month: 'short' }) : null;
  return (
    <div style={{
      background: state.overdue ? '#fef2f2' : '#fff7ed', border: `1px solid ${state.overdue ? '#fecaca' : '#fed7aa'}`,
      color: state.overdue ? '#991b1b' : '#9a3412', borderRadius: 10, padding: '10px 14px', margin: '0 0 14px', fontSize: 14,
    }}>
      Team rules v{state.rules.version} are in force. Please read and acknowledge them{due ? ` by ${due}` : ''}.{' '}
      <Link to="/team-rules" style={{ fontWeight: 600 }}>Open the team rules</Link>
    </div>
  );
};

export default RulesBanner;
